import React from "react";

const CellAndGeneTherapyDescription = () => {
  return (
    <div id="assy-creation-description">
      <h2>Design Engine Description</h2>
      <p>
        The Cell and Gene Therapy (CGT) Design Engine enables you to quickly
        create custom ddPCR optimized assays for your target Gene of Interest
        (GOI). Built by digital PCR experts at Bio-Rad’s Digital Biology Center,
        the CGT Design Engine takes into consideration GC content, Tm, primer
        placement, probe length, and restriction enzyme compatibility when
        designing an assay for you. The design engine also offers a list of
        predesigned Vector Backbone Assays targeting common Viral Vector
        Backbone or Plasmid Elements. Use the custom Gene of Interest or Vector
        Backbone assays individually or multiplex them together. The Cell and
        Gene Therapy Design Engine, a key part of Bio-Rad's Cell and Gene
        Therapy solution, offers the convenience of a quick and robust assay
        design, saving you valuable time so you can focus on important
        experiments.
      </p>

      <strong>In-silico Multiplex Compatibility Checks</strong>
      <p>
        The CGT Design Engine runs an in-silico multiplex compatibility check
        between the Vector Backbone Assay you select, and your Gene of Interest
        assay design. The resulting in-silico multiplex compatibility prediction
        is based on restriction enzyme cut sites. Please note that performance
        of these assays should be validated on your workflow prior to use.
      </p>

      <h3>Assay Description</h3>

      <p>
        ddPCR Cell and Gene Therapy Assays are custom, probe-based assays
        optimized for ddPCR that come in a variety of fluorophores to enable
        multiplexing. These assays offer the ease and accuracy of ddPCR
        technology and can be used in a variety of applications, including Viral
        Titer and Vector Copy Number measurements.
      </p>
      <h3>Key Benefits</h3>
      <ul>
        <li>
          Quick assay design in minutes, saving you valuable time otherwise
          spent designing assays
        </li>
        <li>
          Robust assay design, optimized specifically for ddPCR technology
        </li>
        <li>Vector Backbone Assays available for multiplexing</li>
        <li>In-silico multiplexing checks (wet-lab validation recommended)</li>
        <li>Six probe fluorophore options</li>
        <li>
          Certificate of Analysis provided with each ddPCR CGT Assay order
        </li>
        <li>Assay sequence provided with select catalog numbers</li>
      </ul>
      <h3>Sample Data</h3>
      <img
        src="https://d1vjebusapavbw.cloudfront.net/digital-assays/static/applicationType/cgt/cgt-sample.jpg"
        width="630"
        caption="false"
      />
    </div>
  );
};

export default CellAndGeneTherapyDescription;
